import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {AxiosErrorGeneric} from 'src/utilities/RequestError'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

type UpdateCameraStatusData = {
  ids: number[]
  status: boolean
}

export default function useUpdateCameraStatus() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (data: UpdateCameraStatusData) => {
      return await api.camera.setCamerasStatus(data.ids, data.status)
    },
    onError: (error) => {
      const err = error as unknown as AxiosErrorGeneric
      const errorMessage = err.response.data.devMessage.includes('Quota limit')
        ? 'Cota atingida. Entre em contato com o suporte'
        : 'Erro ao atualizar status da câmera'

      handleErrorWithSnackbar(enqueueSnackbar, error, errorMessage)
    },
    onSettled: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.CAMERA]})
    },
  })

  return mutation
}
